<template>
  <div class="">
    <reservation-extra-item @itemValue="itemValueMethod" v-for="item in reservationExtraOptions"
                            :reservation-item="item"/>
  </div>
</template>


<script>
import ReservationExtraItem from "./ReservationExtraItem.vue";

export default {
  name: "ExtraItems",
  components: {ReservationExtraItem},
  props: {
    reservationRule: {}
  },
  data() {
    return {
      reservationExtraOptions: [],
      selectedItems: [],
    }
  },
  methods: {
    findReservationRuleExtraOptions(rules) {
      return rules.extra_items
    },
    itemValueMethod(data) {
      const mode = data.value === '' ? false : true
      this.$emit('extraItems', {data: data, mode: mode})
    }
  },
  updated() {
    this.reservationExtraOptions = this.findReservationRuleExtraOptions(this.reservationRule)
  }
}
</script>

<style scoped>

</style>